import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { CatalogService } from '@proxy/catalogs';
import { WineDto } from '@proxy/wines';
import { PageTitleService } from '../../services/page-title.service';
import { AuthService, ConfigStateService } from '@abp/ng.core';
import { APP_ICONS } from '../../icons/app-icons';
import { fromEvent, map, startWith, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ShoppingCartService } from '@proxy/shopping-carts';
import { NotificationService } from '../../services/notification.service';
import { ModalCommunicationService } from '../../services/modal-communication.service';
import { SelectedSommelierService } from '../../services/selected-sommelier.service';
import { StorageService } from '../../services/storage.service';
import { CartStateService } from '../../services/cart-state.service';
@Component({
  selector: 'app-metro-product-details',
  templateUrl: './metro-product-details.component.html',
  standalone: false
})
export class MetroProductDetailsComponent implements OnInit {
  wine!: WineDto;
  wineId: string;
  iconBack = APP_ICONS.arrow;
  image: { url: string; name: string } | null = null;
  quantity = 1;
  maxQuantity = 10;
  userId: string;
  iconCart = APP_ICONS.cart

  isDesktop$!: Observable<boolean>;

  @Output() addToCart = new EventEmitter<WineDto>();

  sommelierSlug: string;
  imageLoaded = false;
  hasError = false;

  // winepassport#364 (WP-018) — "Avisame cuando vuelva".
  notifyEmail = '';
  notifyingRestock = false;
  notifyRestockResult: 'success' | 'already-subscribed' | 'error' | null = null;

  constructor(
    private route: ActivatedRoute,
    private catalogService: CatalogService,
    private location: Location,
    private pageTitleService: PageTitleService,
    private authService: AuthService,
    private shoppingCartService: ShoppingCartService,
    private config: ConfigStateService,
    private notificationService: NotificationService,
    private modalCommunicationService: ModalCommunicationService,
    private selectedSommelierService: SelectedSommelierService,
    private storageService: StorageService,
    private cartStateService: CartStateService
  ) { }

  ngOnInit(): void {
    this.isDesktop$ = fromEvent(window, 'resize').pipe(
      map(() => window.innerWidth >= 768),
      startWith(window.innerWidth >= 768)
    );

    const slugFromUrl = this.route.snapshot.parent?.paramMap.get('slug');
    if (slugFromUrl) {
      this.selectedSommelierService.setSlug(slugFromUrl);
    }

    this.selectedSommelierService.getSlug$().subscribe(res => {
      this.sommelierSlug = res;
    });

    this.wineId = this.route.snapshot.paramMap.get('id')!;
    this.catalogService.getWine(Number(this.wineId), this.sommelierSlug).subscribe(res => {
      this.wine = res;
      this.pageTitleService.setTitle(res.name);
    });

    this.config.getOne$('currentUser').subscribe(res => {
      this.userId = res.id;
      if (this.hasLoggedIn && res.email) {
        this.notifyEmail = res.email;
      }
    });
  }

  get isOutOfStock(): boolean {
    return !!this.wine && this.wine.stock <= 0;
  }

  subscribeToRestock(): void {
    if (!this.wine || this.notifyingRestock || !this.notifyEmail?.trim()) return;

    this.notifyingRestock = true;
    this.notifyRestockResult = null;

    this.catalogService.subscribeToRestock(this.wine.id, {
      email: this.notifyEmail.trim(),
      sommelierSlug: this.sommelierSlug || undefined,
    }).pipe(finalize(() => { this.notifyingRestock = false; }))
      .subscribe({
        next: result => {
          this.notifyRestockResult = result.alreadySubscribed ? 'already-subscribed' : 'success';
        },
        error: err => {
          console.error('[ProductDetails] No se pudo suscribir al aviso de reposición', err);
          this.notifyRestockResult = 'error';
        }
      });
  }

  goBack() {
    this.location.back();
  }

  get hasLoggedIn(): boolean {
    return this.authService.isAuthenticated;
  }

  onAddToCart() {
    if (!this.wine || this.quantity < 1 || !this.userId) return;

    this.shoppingCartService.addItem(this.userId, Number(this.wineId), this.quantity)
      .subscribe({
        next: cart => {
          this.notificationService.success('', '::SuccessfullyAdded');
          this.cartStateService.setCount(cart.totalItems); // <-- acá

        },
        error: err => {
          console.error(err);
        }
      });
  }
  goRegister() {
    this.modalCommunicationService.triggerOpenRegisterModal();
  }
  increaseQuantity() {
    if (this.quantity < this.maxQuantity) {
      this.quantity++;
    }
  }

  decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity--;
    }
  }

  onQuantityChange(event: Event) {
    const value = Number((event.target as HTMLInputElement).value);
    this.quantity = Math.max(1, Math.min(this.maxQuantity, value));
  }


  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/no-image.png';
    this.hasError = true;
  }

  getCountryCode(country: string | undefined): string {
  if (!country) return '';
  const normalized = country.trim().toLowerCase();
  const map: Record<string, string> = {
    argentina: 'ar',
    españa: 'es',
    spain: 'es',
    italia: 'it',
    italy: 'it',
    francia: 'fr',
    france: 'fr',
    australia: 'au',
    hungría: 'hu',
    hungary: 'hu'
  };
  return map[normalized] ?? '';
}

}
